import { useState, useEffect } from "react";
import React from 'react';
import { t } from '../locales/translate.js';
import { formatKr, hasPriceBreakdown, priceExplanation, priceTransportation } from '../utils/price.js';
import { useParams } from "react-router-dom";

const statusBadgeClass = (status) => {
    if (status === 'Inlämnad' || status === 'Upphämtad') return 'badge badge-warning';
    if (status === 'Väntar på återtag') return 'badge badge-orange';
    if (status === 'Klar') return 'badge badge-success';
    if (status === 'Kasserad') return 'badge badge-danger';
    return 'badge badge-secondary';
}

function Element({ apiCall, user }) {
    const { id } = useParams(); // Get the report ID from the URL

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});
    const [error, setError] = useState(null);


    useEffect(() => {

        //get key from current url key param
        const query = new URLSearchParams(window.location.search);
        let key = query.get("key") || '';

        // Fetch reports data when the component mounts
        apiCall("GET", `report/${id}/`, { key })
            .then(({ response, error }) => {
                if (error) {
                    setError(t('error_fetching_report_data'));
                    console.error("Error fetching scrap data:", error);
                } else {
                    setData(response);

                }
                setLoading(false);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiCall]);



    if (loading) {
        return <div>{t('loading')}</div>;
    }

    if (error) return (
        <div className="alert alert-danger">{error}</div>
    );

    return (
        <div className="card create-project-form custom-input single-report">
            <div className="card-body">
                <div className="row">
                    <div className="col-12">
                        <div className="col-sm-12 col-xl-12">
                            <div className="card shadow-none border">
                                <div className="card-header">
                                    <h5>{t('report_details')}</h5>
                                </div>
                                <div className="card-body">
                                    <div className="flex-space flex-wrap align-items-center">
                                        {data.created_at && (
                                            <p className="full"><strong>{t('date')}:</strong> {data.created_at.replace('T', ' ').substring(0, 16)}</p>
                                        )}
                                        {data.game_qr && (
                                            <p className="full"><strong>{t('game_id')}:</strong> {data.game_qr}</p>
                                        )}
                                        {data.organ_qr && (
                                            <p className="full"><strong>{t('organ_id')}:</strong> {data.organ_qr}</p>
                                        )}
                                        {data.game_name && (
                                            <p className="full"><strong>{t('game_name')}:</strong> {data.game_name}</p>
                                        )}
                                        {data.depot_name && (
                                            <p className="full"><strong>{t('depot_name')}:</strong> {data.depot_name}</p>
                                        )}
                                        {data.statusName && (
                                            <p className="full"><strong>{t('status')}:</strong> <span className={statusBadgeClass(data.statusName)}>{data.statusName}</span></p>
                                        )}
                                        {data.weight && (
                                            <p className="full"><strong>{t('weight')}:</strong> {data.weight}</p>
                                        )}
                                        {hasPriceBreakdown(data) ? (
                                            Number(data.weight) > 0 && data.price_total !== null && (<>
                                                <p className="full"><strong>{t('price')}:</strong> {formatKr(data.price_total)}</p>
                                                {priceExplanation(data) && (
                                                    <p className="full"><strong>{t('price_calculation')}:</strong> {priceExplanation(data)}</p>
                                                )}
                                                {priceTransportation(data) && (
                                                    <p className="full">{priceTransportation(data)}</p>
                                                )}
                                            </>)
                                        ) : (<>
                                            {data.price && (
                                                <p className="full"><strong>{t('price')}:</strong> {data.price}</p>
                                            )}
                                            {data.price_per_kg && (
                                                <p className="full"><strong>{t('price_per_kg')}:</strong> {data.price_per_kg}</p>
                                            )}
                                        </>)}
                                        {data.notes && (
                                            <p className="full"><strong>{t('notes')}:</strong> {data.notes}</p>
                                        )}
                                        {typeof data.author_certificate !== 'undefined' && (
                                            <p className="full"><strong>{t('certificate')}:</strong> {data.author_certificate ? t('yes') : t('no')}</p>
                                        )}
                                        {typeof data.author_interested_in_meat_return !== 'undefined' && (
                                            <p className="full"><strong>{t('meat_return')}:</strong> {data.author_interested_in_meat_return ? t('yes') : t('no')}</p>
                                        )}
                                        {data.images && data.images.length > 0 && (
                                            <div className="images">
                                                {data.images.map((image, index) => (
                                                    <a key={index} href={`${process.env.REACT_APP_API_HOST}/storage/${image}`} target="_blank" rel="noopener noreferrer">
                                                        <img src={`${process.env.REACT_APP_API_HOST}/storage/${image}`} alt={index + 1} />
                                                    </a>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Element;
